'use es6';

export const SURVEY_KEYS = {
  JOB_ROLE: 'jobRole',
  JOB_FIELD: 'jobField',
  HUB_INTEREST: 'hubInterest',
  CRM_EXPERIENCE: 'crmExperience',
  USAGE_TYPE: 'usageType'
};
export const EXPERIENCE_NONE_PARAM = 'none';
export const EXPERIENCE_HAS_USED_CRM_PARAM = 'has_used_crm';
export const EXPERIENCE_HAS_USED_HUBSPOT = 'has_used_hubspot';
export const SALES_REP_ROLE = 'sales-rep';
export const ADMINISTRATION_OPERATIONS = 'administration-operations';
export const SALES = 'sales';
export const MARKETING = 'marketing';
export const SERVICES_SUPPORT = 'services-support';
export const OTHER = 'other';
export const SALES_HUB_INTEREST = 'sales';
export const MARKETING_HUB_INTEREST = 'marketing';
export const CUSTOMER_SERVICE_HUB_INTEREST = 'customer-service';
export const OPS_HUB_INTEREST = 'operations';
export const GENERAL_OVERVIEW_HUB_INTEREST = 'general-overview';
export const CMS_HUB_INTEREST = 'cms';
export const TRACK_DEALS_USE_CASE = 'track-deals';
export const EMAIL_MARKETING_USE_CASE = 'email-marketing';
export const CONNECT_LEADS_USE_CASE = 'connect-leads';
export const SKIP_USE_CASE = 'skip-use-case';
export const FALSEY_SURVEY_VALUE = [undefined, null, ''];